import {CostDetailItemResponseBody, CostItem} from '@dms/api/core';

import {DEFAULT_CURRENCY_CODE} from '../../../../../constants/DEFAULT_CURRENCY_CODE';
import {CostsData} from '../components/CostsRow';

export const getUpdatedCostItem = (
  row: CostDetailItemResponseBody,
  newData: CostsData
): CostItem => ({
  ...row,
  ...newData,
  cost: (newData.cost ?? 0).toString(),
  note: newData.note ?? '',
  currency: row.currency ?? DEFAULT_CURRENCY_CODE,
});
